var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurvedBg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 551,
    height: 315,
    viewBox: "0 0 551 315",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.617 -200.401C303.335 -191.299 342.088 -163.881 383.986 -139.293C431.501 -111.408 489.196 -95.234 516.431 -47.3394C546.344 5.26448 565.11 75.4005 536.348 128.642C507.776 181.531 429.247 174.279 378.937 207.174C332.613 237.463 310.07 302.299 255.617 312.199C198.643 322.558 138.096 297.258 94.7632 258.841C53.4026 222.171 44.8672 164.014 28.8115 111.119C13.1194 59.4212 -7.28233 8.30916 2.59512 -44.8071C13.3886 -102.849 35.6646 -165.22 85.9494 -196.142C135.351 -226.521 198.651 -211.267 255.617 -200.401Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurvedBg1);
export default __webpack_public_path__ + "static/media/curved-bg1.60a48f4882043a5e69b3593623bc3fc4.svg";
export { ForwardRef as ReactComponent };